import { motion } from "framer-motion";
import { Sparkles, Leaf, Shield } from "lucide-react";

const HERO_BG = "/window-cleaning.png";

const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="hero"
      className="relative w-full overflow-hidden bg-[#101D2C] text-white"
      data-testid="hero-section"
    >
      <div className="hero-split">
      <div className="hero-copy">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="flex items-center gap-3 mb-8"
        >
          <span className="divider-tag on-dark">Résidentiel · Commercial</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="font-display font-black tracking-tight text-5xl sm:text-6xl md:text-7xl lg:text-7xl leading-[0.95] max-w-5xl"
          data-testid="hero-title"
        >
          Des espaces
          <br />
          impeccables.
          <br />
          <span className="text-[#58BCFA]">Tout simplement.</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.45 }}
          className="mt-8 max-w-2xl text-base md:text-lg text-white/80 leading-relaxed font-light"
          data-testid="hero-subtitle"
        >
          Entretien Net Pro — Un service professionnel, fiable et sur
          lequel vous pouvez compter. Résidentiel, lavage de vitres, bureaux, locaux commerciaux, restaurants, hôtels et nettoyage après construction. Un entretien adapté à chaque espace.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.6 }}
          className="mt-10 flex flex-wrap items-center gap-4"
        >
          <button
            onClick={() => scrollTo("contact")}
            data-testid="hero-cta-quote"
            className="group inline-flex items-center gap-3 bg-[#58BCFA] text-[#101D2C] px-7 py-4 font-semibold tracking-wide hover:bg-white transition-all duration-300"
          >
            Demander un devis gratuit

          </button>
          <button
            onClick={() => scrollTo("services")}
            data-testid="hero-cta-services"
            className="inline-flex items-center gap-3 border border-white/40 text-white px-7 py-4 font-semibold tracking-wide hover:bg-white/10 transition-all duration-300"
          >
            Voir nos services
          </button>
        </motion.div>

        {/* Mini trust badges */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.85 }}
          className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-3xl"
        >
          {[
            { icon: Leaf, title: "Résidentiel", desc: "Entretien de votre foyer" },
            { icon: Shield, title: "Commercial", desc: "Bureaux, restaurants, hôtels" },
            { icon: Sparkles, title: "Sur mesure", desc: "Selon vos besoins" },
          ].map((b, i) => {
            const Icon = b.icon;
            return (
              <div
                key={i}
                className="flex items-start gap-3 border-l-2 border-[#58BCFA] pl-4"
                data-testid={`hero-badge-${i}`}
              >
                <Icon className="h-5 w-5 text-[#58BCFA] mt-0.5 flex-shrink-0" />
                <div>
                  <div className="font-semibold text-white text-sm">{b.title}</div>
                  <div className="text-xs text-white/60">{b.desc}</div>
                </div>
              </div>
            );
          })}
        </motion.div>
      </div>

      <div className="hero-photo"><img src={HERO_BG} alt="Professionnel nettoyant une grande vitre avec une raclette" /></div>
      </div>
    </section>
  );
};

export default Hero;
